import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=cb57685e&scoped=true&"
import script from "./clientDetail.vue?vue&type=script&lang=js&"
export * from "./clientDetail.vue?vue&type=script&lang=js&"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=cb57685e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb57685e",
  null
  
)

export default component.exports